import { useAppSelector } from '../../../../store/hooks'
import PageHeader from '../../../layout/page/PageHeader'
import MainContactsForm from './MainContactsForm'

const MainContacts = () => {
    const theme = useAppSelector((state) => state.theme.theme)

    return (
        <>
            <PageHeader
                icon="address-book"
                subtitle="Manage primary contact details and enquiry recipients"
                gradient="linear-gradient(135deg, #0a63ea, #083bb0)"
                header="Main Contacts"
                buttons={[
                    {
                        variant: theme === 'dark' ? 'dark' : 'light',
                        label: 'Back to Administration',
                        icon: 'fa-solid fa-arrow-left',
                        url: '/administration',
                    },
                ]}
            />
            <MainContactsForm
                config={{
                    submitSuccessMsg: {
                        header: 'Updated',
                        message: 'Main Contacts updated successfully',
                    },
                    submitFailedMsg: {
                        header: 'Failed',
                        message: 'Failed to update main contacts links',
                    },
                    saveButton: {
                        label: 'Update',
                        savingLabel: 'Updating main contacts links...',
                    },
                }}
                inPopup={false}
            />
        </>
    )
}

export default MainContacts
